module.exports = __webpack_public_path__ + "img/25.a02d8d51.jpg";